export const constant = {
	selector: {
		target: 'data-m-search',
	},
}
